import React, { useEffect, useState } from "react";
import { useLocation } from 'react-router-dom';
import "./component.css";
import { URL, WEBSITE } from "../../../lib/lib";

// Category list
// const categories = ["All", "Best Seller", "Veg", "Non Veg"];

// Food items
// const initialItems = [
//   {
//     title: "Sambar Dosa",
//     price: "2.5 ₹",
//     category: "Veg",
//     img: "/image/food.png",
//     quantity: 1,
//     description: "South Indian breakfast favorite",
//   },
//   {
//     title: "Idli Vada",
//     price: "1.5 ₹",
//     category: "Veg",
//     img: "/image/idlii.png",
//     quantity: 1,
//     description: "Steamed rice cakes and fried lentil donuts",
//   },
//   {
//     title: "Paneer Roll",
//     price: "3.0 ₹",
//     category: "Best Seller",
//     img: "/image/idlii.png",
//     quantity: 1,
//   },
//   {
//     title: "Aloo Paratha",
//     price: "2.0 ₹",
//     category: "Best Seller",
//     img: "/image/jio.png",
//     quantity: 1,
//   },
//   {
//     title: "Chicken Biryani",
//     price: "4.5 ₹",
//     category: "Non Veg",
//     img: "/image/chiki.png",
//     quantity: 1,
//   },
//   {
//     title: "Aloo Paratha",
//     price: "2.0 ₹",
//     category: "Non Veg",
//     img: "/image/jio.png",
//     quantity: 1,
//   },
// ];

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default function FoodPageWithTabs() {
  const [activeCategory, setActiveCategory] = useState("All");
  const [items, setItems] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  const query = useQuery();
  const hotelId = query.get('hotelId');
  const tableId = query.get('tableId');

  useEffect(() => {
    if (!hotelId || !tableId) return;

    async function fetchMenuData() {
      try {
        const response = await fetch(`${URL}/api/menu/view?hotelId=${hotelId}&tableId=${tableId}`);
        const data = await response.json();
        // setMenu(data);
          if (data.success) {
            const formatted = data.data.map(product => ({
              title: product?.productId?.name,
              mrp: `${product?.productId?.mrp} ₹`,
              price: `${product?.productId?.confirmPrice} ₹`,
              category: product?.productId?.categoryId?.name || "Uncategorized",
              img: `${URL}/uploads/${product?.productId?.images?.[0] || "/image/food.png"}`,
              quantity: 1,
              description: product?.productId.description || ""
            }));
            setItems(formatted);
          }
      } catch (error) {
        console.error("Error fetching menu:", error);
      } finally {
        setLoading(false);
      }
    }

    fetchMenuData();
  }, [hotelId, tableId]);


  useEffect(() => {
    fetchCategories();
    // fetchMenuItems();
  }, []);

  const fetchCategories = async () => {
    try {
      const response = await fetch(URL + WEBSITE.category_view, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
      });
      const data = await response.json();
      if (data.success) {
        const names = data.data.map((cat) => cat.name);
        setCategories(["All", ...names]);
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  const filteredItems = activeCategory === "All" ? items : items.filter((item) => item.category === activeCategory);

  const increaseQty = (index) => {
    const updated = [...filteredItems];
    updated[index].quantity += 1;
    setItems( items.map((item) => item.title === updated[index].title ? updated[index] : item ));
  };

  const decreaseQty = (index) => {
    const updated = [...filteredItems];
    if (updated[index].quantity > 1) {
      updated[index].quantity -= 1;
      setItems( items.map((item) => item.title === updated[index].title ? updated[index] : item));
    }
  };

  if (loading) return <p>Loading...</p>;

  return (
    <div style={{ paddingBottom: "3rem" }}>
      <div className="tab-scroll-wrapper">
        {categories.map((cat, index) => (
          <div
            key={index}
            className={`tab-item ${activeCategory === cat ? "active" : ""}`}
            onClick={() => setActiveCategory(cat)}
          >
            {cat}
          </div>
        ))}
      </div>

      {/* Food Grid */}
      <div className="container py-3 d-block d-md-none">
        <div className="row g-3">
          {filteredItems.length === 0 ? (
            <div className="text-center">No items found.</div>
          ) : (
            filteredItems.map((item, index) => (
              <div className="col-12" key={index}>
                <div className="food-card p-2 d-flex align-items-start border rounded shadow-sm">
                  <img
                    src={item.img}
                    alt={item.title}
                    className="rounded img-fluid me-2"
                    style={{
                      width: "100px",
                      height: "100px",
                      objectFit: "cover",
                    }}
                  />
                  <div className="flex-grow-1">
                    <h6 className="mb-1 fw-semibold">{item.title}</h6>
                    <div className="text-muted small">
                      <span className="text-dark fw-bold me-2">
                        {item.price}
                      </span>
                      <span>{item.category}</span>
                    </div>
                    {item.description && (<p className="small text-muted mt-1">{item.description}</p>)}
                  </div>
                  <div className="quantity-box ms-2 text-white rounded d-flex align-items-center px-2 qty-clr">
                    <button className="btn btn-sm text-white px-1 py-0" onClick={() => decreaseQty(index)}>-</button>
                    <span className="mx-1 fw-semibold">{item.quantity}</span>
                    <button className="btn btn-sm text-white px-1 py-0" onClick={() => increaseQty(index)}>+</button>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}
